var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ServiceBase, ServiceEndPoints } from "@/modules/services/models/ServiceBase";
var UploadServices = (function (_super) {
    __extends(UploadServices, _super);
    function UploadServices() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UploadServices.prototype.uploadFile = function (file, conf) {
        if (conf === void 0) { conf = undefined; }
        if (!conf)
            conf = {};
        var address = ServiceEndPoints.UPLOAD_SERVICES;
        var data = new FormData();
        var config = __assign(__assign({}, conf), { headers: {
                'Content-Type': 'multipart/form-data'
            } });
        data.append("file", file);
        data.append('Folder', 'UsersFiles\\Temp');
        return this.postData(address, data, config);
    };
    UploadServices.prototype.uploadBlob = function (blob, fileName, conf) {
        if (conf === void 0) { conf = undefined; }
        var file = new File([blob], fileName);
        return this.uploadFile(file, conf);
    };
    return UploadServices;
}(ServiceBase));
export { UploadServices };
export var uploadServices = new UploadServices();



//////////////////
// WEBPACK FOOTER
// ./src/modules/commons/services/UploadServices.ts
// module id = null
// module chunks = 